import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // 14 minutes and 50 seconds in seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-[#16a34a] text-white py-1 px-4 shadow-sm text-center" data-id="element-1">
      <div className="flex items-center justify-center gap-2 font-bold text-sm md:text-base animate-pulse" data-id="element-2">
        <Clock className="h-4 w-4" data-id="element-3" />
        <span data-id="element-4">⏳ OFERTA EXPIRA EN: {formatTime(timeLeft)}</span>
      </div>
    </div>;
}